module.exports = __webpack_public_path__ + "static/flags/AO-948d310ce2812432780cd145e772b566.gif";